import { shallowRef } from '@vue/composition-api'
import { fetchSportsProduct } from '@ms/api/match'
import { useState } from '@ms/utils/useState'
import { getStorage, setStorage } from '@ms/fetch/cache'
import { batchUpdateSportsMap } from './map.js'

const C_SPORTS = 'C_SPORTS'
const C_ESPORTS_CONFIG = 'C_ESPORTS_CONFIG'

// available sports store
export default function useSportsAvailable() {
  const esportConfig = shallowRef({})
  const {
    state: sportsAvailable,
    loading: loadingAvailableSports,
    setState,
    request: getAvailableSports
  } = useState([], {
    fetchData: async () => {
      if (sportsAvailable.length === 0) {
        const [cSports, cEsportsConfig] = await Promise.all([getStorage(C_SPORTS), getStorage(C_ESPORTS_CONFIG)])
        if (cSports) {
          setState(cSports)
          esportConfig.value = cEsportsConfig
        }
      }
      const { error, data } = await fetchSportsProduct()
      if (error) return { error }
      return { data: parseAvailableSports(data) }
    }
  })

  const parseAvailableSports = ({ sports, esportIds, esportPosition }) => {
    esportConfig.value = { esportIds, esportPosition }
    batchUpdateSportsMap(sports)
    setStorage(C_SPORTS, sports)
    setStorage(C_ESPORTS_CONFIG, esportConfig.value)
    return sports
  }

  const setBffAvailableSports = (data) => {
    const list = parseAvailableSports(data)
    setState(list)
  }

  return {
    sportsAvailable,
    loadingAvailableSports,
    getAvailableSports,
    esportConfig,
    setBffAvailableSports
  }
}
